import * as React from "react";
import { Select } from "react-ui";
import { useEffect, useState } from "react";

export interface FilterSelectFilterInfo {
    id: string;
    caption: string;
    separated?: boolean;
}

export interface FilterSelectProps {
    filterId: undefined | string;
    filters: FilterSelectFilterInfo[];
    emptyItemName?: string;
    onApplyFilter: (id: undefined | string | null) => void;
    width?: string | number;
}

type FilterSelectItems = Array<[string | undefined, string] | typeof Select.SEP>;
export function FilterSelect(props: FilterSelectProps): JSX.Element {
    const [selectItems, setSelectItems] = useState<FilterSelectItems>();

    useEffect(() => {
        const items: FilterSelectItems = [[undefined, props.emptyItemName ?? ""]];

        for (const item of props.filters) {
            items.push([item.id, item.caption]);

            if (item?.separated) {
                items.push(Select.SEP);
            }
        }

        setSelectItems(items);
    }, [JSON.stringify(props.filters)]);

    return (
        <Select<undefined | string | null, string>
            width={props.width}
            placeholder={props.emptyItemName}
            value={props.filterId ?? null}
            items={selectItems}
            onValueChange={props.onApplyFilter}
            data-tid="filterSelect"
        />
    );
}
